import { PaginationResult } from "../../../../Shared/Model/PaginationResult";
import { Products } from "../Model/Products";
import { ProductRepository } from "../Repository/ProductRepository";

export interface GetProducstUseCase {
  invoke: (page: number, pageSize: number, search: string) => Promise<PaginationResult<Products>>;
}

export class GetProducts implements GetProducstUseCase {
  private productRepo: ProductRepository;
  constructor(_ProductRepo: ProductRepository) {
    this.productRepo = _ProductRepo;
  }

   invoke(page: number, pageSize: number, search: string){
    const getData = this.productRepo.getProducts(page, pageSize, search);
    return getData;
  }
}